// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27l9a","colBig":"styles_colBig__1RXVC","colSmall":"styles_colSmall__3dPiw","shopifyNameWrapper":"styles_shopifyNameWrapper__2WpER"};